import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class InsightsGlobalEntityGroup extends ApplicationRecord {
  static jsonapiType = "insights_global_entity_groups";

  @Attr() name: string;

  @Attr() archived: boolean;

  @Attr() archivedAt: string;
}

export default InsightsGlobalEntityGroup;
